// Page tunnel "Commander mon tamis" (/pages/commander-mon-tamis) — voir
// sections/commander-tamis.liquid pour le contrat d'URL et les regles.
//
// Mode recompense : le tamis est celui du code HX-R-<CO|EQ|PU>-... (cookie
// discount_code), verrouille ; texture, finition et couleur du logo libres.
// Mode libre : voir plus bas. Ajout panier : memes cles de proprietes et meme propriete
// cachee _config_id que assets/configurateur.js, pour que la page panier
// regroupe les lignes en une carte et que fabrication/commande lisent les
// memes champs. _tamis_order marque la ligne : le panier n'affiche alors pas
// "Modifier ma configuration" (le tamis de recompense ne se change que depuis
// l'espace compte). Quantite toujours 1 sur chaque ligne.
(function () {
  var root = document.querySelector('[data-tamis-order]');
  var D = window.HexagonTamisOrder;
  if (!root || !D) return;

  // Le configurateur tamis est AUTONOME : il fonctionne toujours, quels que
  // soient l'URL et les cookies (achat libre, plein tarif, choix du tamis et de
  // la texture). La recompense n'est qu'une SURCHARGE facultative, jamais un
  // prerequis ; si quoi que ce soit est incoherent, on retombe sur l'achat libre
  // (aucun ecran d'erreur).
  //
  // Surcharge recompense : le cookie discount_code (pose par /discount/<code>)
  // contient un code HX-R-<CO|EQ|PU>-XXXXXXXX. Le tamis est alors CELUI DU CODE
  // (CO = Controle, EQ = Equilibre, PU = Puissance), verrouille, jamais celui de
  // l'URL ; texture, finition et logo restent libres ; remise affichee sur le
  // tamis seul ; connexion requise. Ancien format sans lettre (HX-R-XXXXXXXX) :
  // pris en compte seulement si ?tamis= est un tamis valide.
  var CODE_TAMIS = { CO: 'tamis-controle', EQ: 'tamis-equilibre', PU: 'tamis-puissance' };
  var cookieMatch = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
  var cookieCode = '';
  if (cookieMatch) { try { cookieCode = decodeURIComponent(cookieMatch[1]).trim(); } catch (e) { cookieCode = ''; } }
  var typed = /^HX-R-(CO|EQ|PU)-/i.exec(cookieCode);
  var legacy = !typed && /^HX-R-/i.test(cookieCode);
  var params = new URLSearchParams(window.location.search);
  function usable(key) { return !!(key && D.tamis[key] && D.tamis[key].variantId); }
  var rewardTamis = '';
  if (typed && usable(CODE_TAMIS[typed[1].toUpperCase()])) rewardTamis = CODE_TAMIS[typed[1].toUpperCase()];
  else if (legacy && usable(params.get('tamis'))) rewardTamis = params.get('tamis');
  var locked = !!rewardTamis;
  var sel = { tamis: '', texture: 'texturee' };
  if (locked) sel.tamis = rewardTamis;
  else if (usable(params.get('tamis'))) sel.tamis = params.get('tamis'); // simple preselection
  else {
    // Tamis par defaut : Equilibre s'il est vendable, sinon le premier qui l'est.
    var order = ['tamis-equilibre', 'tamis-controle', 'tamis-puissance'];
    sel.tamis = order.filter(function (k) { return usable(k); })[0] || '';
  }
  if (!sel.tamis) return; // aucun tamis vendable (produits absents) : on ne rend rien
  function T() { return D.tamis[sel.tamis]; }
  function X() { return D.textures[sel.texture]; }
  var rewardPct = locked ? (D.discountPercent || 0) : 0;
  root.hidden = false;
  if (locked) q('[data-tamis-perf-title]').textContent = 'Surface de frappe';
  root.querySelectorAll('[data-tamis-mode]').forEach(function (el) {
    el.hidden = el.getAttribute('data-tamis-mode') !== (locked ? 'locked' : 'free');
  });

  var LOGO_CHOICES = [
    { id: 'logo-tricolore', label: 'Tricolore', hex: null, suffix: 'tricolore' },
    { id: 'logo-gold', label: 'Doré', hex: '#C7A24A', suffix: 'dore' },
    { id: 'logo-red', label: 'Rouge', hex: '#ED2939', suffix: 'rouge' },
    { id: 'logo-green', label: 'Vert', hex: '#1B4332', suffix: 'vert' },
    { id: 'logo-blue', label: 'Bleu', hex: '#002395', suffix: 'bleu' }
  ];
  var FINISH_LABELS = { brut: 'Brut', fibres: 'Fibres metalliques', flocons: 'Flocons metalliques', paillettes: 'Paillettes' };
  var FINISH_TABS = [{ id: 'brut', label: FINISH_LABELS.brut }].concat(
    ['fibres', 'flocons', 'paillettes']
      .filter(function (type) { return D.finitions.some(function (f) { return f.type === type; }); })
      .map(function (type) { return { id: type, label: FINISH_LABELS[type] }; })
  );
  function brutOnly() { return T().slug === 'controle'; }

  var state = { finish: 'brut', accentColor: '', logoColor: 'logo-tricolore' };
  var selectedPhotoIndex = 1;

  function q(sel) { return root.querySelector(sel); }
  function fmt(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '').replace('.', ',');
    return s + ' €';
  }
  function logoData() {
    return LOGO_CHOICES.filter(function (l) { return l.id === state.logoColor; })[0];
  }
  function paletteFor(type) {
    return D.finitions
      .filter(function (f) { return f.type === type; })
      .sort(function (a, b) { return a.order - b.order; })
      .map(function (f) { return { id: f.couleur, name: f.label, active: !!f.actif }; });
  }
  function finishSummary() {
    var tab = FINISH_TABS.filter(function (t) { return t.id === state.finish; })[0];
    if (!tab) return '';
    if (state.finish === 'brut' || !state.accentColor) return tab.label;
    var color = paletteFor(state.finish).filter(function (c) { return c.id === state.accentColor; })[0];
    return tab.label + ' ' + (color ? color.name : '');
  }
  function addon() { return D.addons[state.finish] || null; }

  // --- Tracking GA4 (assets/hexagon-tracking.js, docs/tracking-ga4.md) : memes regles que le
  // configurateur raquette, avec configurator_type = tamis_only. ---
  // Seul le groupe CLIQUE (data-tamis-group) est trace ; les valeurs recalculees automatiquement par
  // renderAll() ne sont pas des selections de l'utilisateur. Le choix du tamis lui-meme ('tamis')
  // compte pour configurator_start mais n'est pas une personnalisation esthetique.
  var TRACK_GROUPS = {
    texture: { key: 'texture', name: 'texture' },
    finish: { key: 'finish', name: 'finish' },
    color: { key: 'accentColor', name: 'accent_color' },
    logo: { key: 'logoColor', name: 'logo_color' }
  };
  function trackSnapshot() {
    return { finish: state.finish, accentColor: state.accentColor, logoColor: state.logoColor, texture: sel.texture, tamis: sel.tamis };
  }
  function trackChoice(before, groupName) {
    var Tk = window.HexagonTracking;
    if (!Tk) return;
    Tk.started('tamis_only');
    var g = TRACK_GROUPS[groupName];
    if (!g) return;
    var now = trackSnapshot();
    if (now[g.key] === before[g.key] || !now[g.key]) return;
    Tk.customization('tamis_only', g.name, String(now[g.key]), 'aesthetic');
  }
  function trackingConfig(configId) {
    return {
      configId: configId,
      tamis: sel.tamis,
      texture: sel.texture,
      finish: state.finish,
      accentColor: state.accentColor || 'none',
      logoColor: state.logoColor,
      engraving: 'none'
    };
  }
  var openingConfigId = null;
  function makeOption(className, active, disabled, html, onClick) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'option ' + className;
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (disabled) {
      el.classList.add('option--disabled');
      el.disabled = true;
    } else {
      el.addEventListener('click', function (ev) {
        var before = trackSnapshot();
        var holder = el.closest('[data-tamis-group]');
        var groupName = holder ? holder.getAttribute('data-tamis-group') : '';
        var result = onClick.call(this, ev);
        try { trackChoice(before, groupName); } catch (trackErr) { /* ignore */ }
        return result;
      });
    }
    el.innerHTML = '<span class="option__inner">' + html + '</span>';
    return el;
  }
  function pillLabelHtml(label) {
    return label.replace(/ metalliques$/i, ' <span class="config-word-metallique">metalliques</span>');
  }

  // --- Choix libre (mode tous clients) ---
  function renderFreeChoice() {
    var tw = q('[data-tamis-group="tamis"]');
    tw.innerHTML = '';
    if (!locked) Object.keys(D.tamis).forEach(function (key) {
      var t = D.tamis[key];
      tw.appendChild(makeOption('option--style', sel.tamis === key, !t.available, '<span class="option__title">' + t.label + '</span>', function () {
        sel.tamis = key;
        if (brutOnly()) { state.finish = 'brut'; state.accentColor = ''; }
        renderAll();
      }));
    });
    var descEl = q('[data-tamis-style-desc]');
    if (descEl && !locked) {
      var r = (D.raquettes || []).filter(function (x) { return x.id === T().styleId; })[0];
      descEl.textContent = r ? r.desc : '';
    }

    var xw = q('[data-tamis-group="texture"]');
    xw.innerHTML = '';
    var tip = document.createElement('div');
    tip.className = 'option__info-tooltip option__info-tooltip--shared';
    tip.hidden = true;
    Object.keys(D.textures).forEach(function (key) {
      var x = D.textures[key];
      var swatch = x.swatch
        ? '<span class="option__swatch-img" style="background-image:url(' + x.swatch + ')"></span>'
        : '<span class="option__swatch-img option__swatch-img--placeholder"></span>';
      var price = x.price > 0 ? '<span class="option__swatch-price">(+' + fmt(x.price) + ')</span>' : '';
      var info = x.description ? '<span class="option__info" data-info tabindex="0"><span class="option__info-mark" aria-hidden="true">i</span></span>' : '';
      var meta = (price || info) ? '<span class="option__swatch-meta">' + price + info + '</span>' : '';
      var text = '<span class="option__swatch-text"><span class="option__swatch-label">' + x.label + '</span>' + meta + '</span>';
      var el = makeOption('option--swatch ' + (key === 'sablee' ? 'option--swatch-texture-lg' : 'option--swatch-texture-sm'), sel.texture === key, false, swatch + text, function () {
        sel.texture = key;
        renderAll();
      });
      var toggle = el.querySelector('[data-info]');
      if (toggle) {
        toggle.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var same = !tip.hidden && tip.getAttribute('data-active') === key;
          tip.hidden = same;
          if (same) { tip.removeAttribute('data-active'); } else { tip.textContent = x.description; tip.setAttribute('data-active', key); }
        });
      }
      xw.appendChild(el);
    });
    xw.appendChild(tip);
  }

  // --- Etapes ---
  function renderFinish() {
    var wrap = q('[data-tamis-group="finish"]');
    wrap.innerHTML = '';
    FINISH_TABS.forEach(function (tab) {
      var disabled = tab.id !== 'brut' && brutOnly();
      wrap.appendChild(makeOption('option--pill', state.finish === tab.id, disabled, '<span>' + pillLabelHtml(tab.label) + '</span>', function () {
        state.finish = tab.id;
        if (tab.id === 'brut') state.accentColor = '';
        renderAll();
      }));
    });
    q('[data-tamis-deco-note]').hidden = !brutOnly();

    var colorWrap = q('[data-tamis-group="color"]');
    colorWrap.innerHTML = '';
    var showColors = state.finish !== 'brut' && !brutOnly();
    colorWrap.hidden = !showColors;
    if (!showColors) return;
    var palette = paletteFor(state.finish);
    var selected = palette.filter(function (c) { return c.id === state.accentColor; })[0];
    if (!selected || !selected.active) {
      var firstActive = palette.filter(function (c) { return c.active; })[0];
      state.accentColor = firstActive ? firstActive.id : (palette.length ? palette[0].id : '');
    }
    var textures = D.finishTextures[state.finish] || {};
    palette.forEach(function (c) {
      colorWrap.appendChild(makeOption(
        'option--swatch',
        state.accentColor === c.id,
        !c.active,
        '<span class="option__swatch-img" style="background-image:url(' + (textures[c.id] || '') + ')"></span><span class="option__swatch-label">' + c.name + '</span>',
        function () { state.accentColor = c.id; renderAll(); }
      ));
    });
  }

  function renderLogo() {
    var wrap = q('[data-tamis-group="logo"]');
    wrap.innerHTML = '';
    LOGO_CHOICES.forEach(function (l) {
      var bg = l.hex ? l.hex : 'linear-gradient(to right, #002395 0 33.33%, #fff 33.33% 66.66%, #ED2939 66.66% 100%)';
      wrap.appendChild(makeOption(
        'option--pill',
        state.logoColor === l.id,
        false,
        '<span class="option__swatch" style="background:' + bg + '"></span><span class="option__swatch-label">' + l.label + '</span>',
        function () { state.logoColor = l.id; renderAll(); }
      ));
    });
  }

  // --- Apercu (photo du tamis + calque logo) ---
  function finitionKey() {
    return state.finish === 'brut' ? 'brut' : (state.finish + '-' + state.accentColor);
  }
  function photoUrl(n) { return D.media.photos[T().slug + '|' + finitionKey() + '|' + n] || ''; }
  function logoUrl(n) { return D.media.logos[n + '|' + logoData().suffix] || ''; }
  function placeholderHtml(label) {
    return '<div class="media-placeholder media-placeholder--square media-placeholder--sable"><span class="media-placeholder__label">' + label + '</span></div>';
  }
  function photoCellHtml(n, label) {
    var photo = photoUrl(n);
    if (!photo) return placeholderHtml(label);
    var overlay = logoUrl(n);
    var html = '<div class="configurateur__photo-cell configurateur__photo-cell--pending"><img src="' + photo + '" alt="" loading="lazy">';
    if (overlay) html += '<img src="' + overlay + '" alt="" loading="lazy" class="configurateur__photo-overlay">';
    return html + '</div>';
  }
  // Photo et calque apparaissent ensemble (meme logique que le configurateur).
  function wirePhotoCell(container, label) {
    var cell = container.querySelector('.configurateur__photo-cell');
    if (!cell) return;
    var imgs = cell.querySelectorAll('img');
    var pending = imgs.length;
    function done() { pending--; if (pending <= 0) cell.classList.remove('configurateur__photo-cell--pending'); }
    imgs.forEach(function (img, i) {
      function fail() {
        if (i === 0) { container.innerHTML = placeholderHtml(label); return; }
        img.remove();
        done();
      }
      if (img.complete) { if (img.naturalWidth > 0) done(); else fail(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', fail, { once: true });
    });
  }
  function renderPreview() {
    var label = 'Rendu produit — évolue avec la couleur du logo et la finition';
    var main = q('[data-tamis-main]');
    main.innerHTML = photoCellHtml(selectedPhotoIndex, label);
    wirePhotoCell(main, label);
    root.querySelectorAll('[data-tamis-thumb]').forEach(function (thumb, i) {
      var n = i + 1;
      var slot = thumb.querySelector('.option__inner');
      slot.innerHTML = photoCellHtml(n, 'Photo ' + n);
      wirePhotoCell(slot, 'Photo ' + n);
      thumb.setAttribute('aria-pressed', n === selectedPhotoIndex ? 'true' : 'false');
    });
  }
  root.querySelectorAll('[data-tamis-thumb]').forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { selectedPhotoIndex = i + 1; renderPreview(); });
  });

  // --- Recap et prix ---
  // Remise informative : pct % du tamis SEUL. La vraie remise
  // est calculee par Shopify avec le code ; les finitions payantes en sont exclues.
  function pricing() {
    var sablee = sel.texture === 'sablee' ? X().price : 0;
    var a = addon();
    var addonPrice = a ? a.price : 0;
    var discountable = T().price;
    var discount = discountable * (rewardPct || 0) / 100;
    return { sablee: sablee, addonPrice: addonPrice, discountable: discountable, discount: discount, before: discountable + sablee + addonPrice, total: discountable - discount + sablee + addonPrice };
  }
  function renderRecap() {
    var p = pricing();
    q('[data-tamis-fixed="tamis"]').textContent = T().label;
    q('[data-tamis-recap="tamis"]').textContent = T().label;
    q('[data-tamis-recap="texture"]').textContent = X().label;
    q('[data-tamis-recap="texture-price"]').textContent = p.sablee > 0 ? ' (+' + fmt(p.sablee) + ')' : '';
    q('[data-tamis-recap="finish"]').textContent = finishSummary();
    q('[data-tamis-recap="finish-price"]').textContent = p.addonPrice > 0 ? ' (+' + fmt(p.addonPrice) + ')' : '';
    q('[data-tamis-recap="logo"]').textContent = logoData().label;

    var reward = rewardPct > 0;
    root.querySelectorAll('[data-tamis-reward-row]').forEach(function (el) { el.hidden = !reward; });
    // Avec une option payante, la remise (sur le tamis seul) n'est plus 50 % du total : le pourcentage est omis.
    q('[data-tamis-reward-label]').textContent = (p.sablee + p.addonPrice > 0) ? 'Votre récompense' : 'Votre récompense (−' + rewardPct + ' %)';
    q('[data-tamis-total-label]').textContent = reward ? 'Prix avec votre récompense' : 'Prix';
    q('[data-tamis-recap="price-old"]').textContent = fmt(p.before);
    q('[data-tamis-recap="discount"]').textContent = '−' + fmt(p.discount);
    q('[data-tamis-recap="price"]').textContent = fmt(p.total);
  }

  function renderAll() {
    renderFreeChoice();
    renderFinish();
    renderLogo();
    renderPreview();
    renderRecap();
  }

  // --- Connexion requise ---
  var ctaWrap = q('[data-tamis-cta-wrap]');
  var loginBox = q('[data-tamis-login]');
  var needLogin = locked && D.requireLogin && !D.loggedIn;
  if (ctaWrap && needLogin) {
    ctaWrap.hidden = true;
    if (loginBox) {
      loginBox.hidden = false;
      var link = loginBox.querySelector('[data-tamis-login-link]');
      if (link) {
        var back = window.location.pathname + window.location.search;
        link.href = link.getAttribute('href').split('?')[0] + '?return_url=' + encodeURIComponent(back);
      }
    }
  }

  // --- Ajout panier ---
  var ctaBtn = q('[data-tamis-cart-cta]');
  var ctaLabel = ctaBtn ? ctaBtn.querySelector('span') : null;
  var ctaDefault = ctaLabel ? ctaLabel.textContent : '';
  var errorEl = q('[data-tamis-error]');
  var isSubmitting = false;

  function track(name, detail) {
    var full = 'hexagon:tamis-order-' + name;
    document.dispatchEvent(new CustomEvent(full, { detail: detail || {} }));
    if (window.HexagonAnalytics) window.HexagonAnalytics.publish(full, detail || {});
  }
  function setSubmitting(loading) {
    isSubmitting = loading;
    if (!ctaBtn) return;
    ctaBtn.classList.toggle('btn--disabled', loading);
    ctaBtn.setAttribute('aria-disabled', loading ? 'true' : 'false');
    if (ctaLabel) ctaLabel.textContent = loading ? 'Ajout en cours…' : ctaDefault;
  }
  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  // Un seul tamis de recompense par panier : si un tamis "recompense" est deja
  // dans le panier (clic repete, retour arriere), ses lignes sont retirees
  // avant le nouvel ajout plutot que dupliquees.
  function removePreviousOrder() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = {};
        cart.items.forEach(function (i) {
          if (i.properties && i.properties._tamis_order && i.properties._config_id) ids[i.properties._config_id] = true;
        });
        var keys = cart.items
          .filter(function (i) { return i.properties && ids[i.properties._config_id]; })
          .map(function (i) { return i.key; });
        return keys.reduce(function (chain, key) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve());
      });
  }

  function submit() {
    if (isSubmitting || needLogin) return;
    if (errorEl) errorEl.hidden = true;
    if (!T().available) {
      showError('Ce tamis n’est pas disponible à la vente pour le moment.');
      return;
    }
    setSubmitting(true);
    track('add-click', { tamis: T().slug, texture: sel.texture });

    var logo = logoData();
    var configId = 'tam_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    var props = {
      _config_id: configId,
      _tamis_order: '1',
      _display_name: 'Tamis Hexagon — ' + T().label,
      _photo_url: photoUrl(1),
      _logo_url: logoUrl(1),
      _config_json: JSON.stringify({ tamis: sel.tamis, texture: sel.texture, finish: state.finish, accentColor: state.accentColor, logoColor: state.logoColor }),
      'Type de jeu': T().label,
      'Surface de frappe': X().label,
      'Couleur surface': finishSummary(),
      'Couleur logo': logo.label
    };
    var items = [{ id: T().variantId, quantity: 1, properties: props }];
    // Une ligne n'existe que si elle facture quelque chose (regle du configurateur).
    if (sel.texture === 'sablee' && X().variantId && X().price > 0) {
      items.push({ id: X().variantId, quantity: 1, properties: { _config_id: configId, 'Pour': T().label } });
    }
    var a = addon();
    if (a && a.id && a.price > 0) {
      items.push({ id: a.id, quantity: 1, properties: { _config_id: configId, 'Pour': T().label + ' — ' + finishSummary() } });
    }

    removePreviousOrder()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'L’ajout au panier n’a pas abouti. Réessayez.'); });
        return res.json();
      })
      .then(function () {
        track('add-success', { tamis: T().slug, texture: sel.texture });
        try { if (window.HexagonTracking) window.HexagonTracking.completed('tamis_only', trackingConfig(configId)); } catch (trackErr) { /* ignore */ }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        setSubmitting(false);
        track('add-error', { message: err.message });
        showError(err.message || 'L’ajout au panier n’a pas abouti. Réessayez.');
      });
  }

  if (ctaBtn) {
    ctaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      submit();
    });
  }

  // Volets mobile (Esthetique) : ouverts en desktop, fermes en mobile.
  var folds = root.querySelectorAll('[data-config-fold]');
  var mql = window.matchMedia('(min-width: 901px)');
  function syncFolds(e) { folds.forEach(function (el) { el.open = e.matches; }); }
  if (typeof mql.addEventListener === 'function') mql.addEventListener('change', syncFolds);

  // Barre flottante mobile : visible tant que l'apercu est a l'ecran et que le
  // bouton du recap ne l'est pas (meme logique que le configurateur).
  var floatBar = document.querySelector('[data-tamis-float]');
  var recapEl = q('.configurateur__recap');
  var firstVisual = q('.configurateur__preview .cadre-hex');
  if (floatBar && needLogin) floatBar.hidden = true;
  if (floatBar && !needLogin && ctaBtn && firstVisual && 'IntersectionObserver' in window) {
    var visualVisible = false;
    var recapReached = false;
    var updateFloat = function () { floatBar.classList.toggle('is-visible', visualVisible && !recapReached); };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visualVisible = en.intersectionRatio >= 0.6; updateFloat(); });
    }, { threshold: [0, 0.6, 1] }).observe(firstVisual);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { recapReached = en.intersectionRatio >= 0.5; updateFloat(); });
    }, { threshold: [0, 0.5, 1] }).observe(ctaBtn);
    var floatCta = floatBar.querySelector('[data-tamis-float-cta]');
    if (floatCta) floatCta.addEventListener('click', function () { recapEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }

  // --- Phase "opening" : bloc "Etre informe du lancement" (meme mecanique que le
  // configurateur de la homepage). Le formulaire de contact natif est intercepte
  // par window.HexagonContactForm (toast, pas de rechargement) ; le corps du
  // message recoit un resume du tamis configure. Une erreur de resume ne doit
  // jamais empecher l'envoi.
  try {
    var notifyForm = document.getElementById('TamisNotifyForm');
    var notifyBody = q('[data-tamis-notify-body]');
    var notifyWrap = q('[data-tamis-notify]');
    if (notifyForm && notifyBody && notifyWrap && window.HexagonContactForm) {
      window.HexagonContactForm.init(notifyForm, {
        trackingConfig: function () {
          if (!openingConfigId) openingConfigId = 'tam_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
          return trackingConfig(openingConfigId);
        },
        successTitle: notifyWrap.getAttribute('data-toast-success-title'),
        successText: notifyWrap.getAttribute('data-toast-success-text'),
        beforeSubmit: function () {
          try {
            notifyBody.value = [
              'Cette personne a configuré un tamis et souhaite être informée du lancement.',
              '',
              'Configuration en cours :',
              '- Tamis : ' + T().label,
              '- Surface de frappe : ' + X().label,
              '- Couleur surface : ' + finishSummary(),
              '- Couleur logo : ' + logoData().label
            ].join('\n');
          } catch (summaryErr) {
            notifyBody.value = 'Cette personne a configuré un tamis et souhaite être informée du lancement.';
          }
        }
      });
    }
  } catch (notifyInitErr) { /* le formulaire natif reste utilisable */ }

  renderAll();
})();
